export const datepickerConfig = {
  minimumNights: 0,
  maximumNightsDefault: 7,
  maximumNightsExtended: 21,
  forceEndDate: false,
  firstAvailableDay: 2,
  lastAvailableDay: 14
};
